import CreateNewTag from "./CreateNewTag";

interface CreateNewTagProps {
    productTagDetails: any;
    pageMode: string;
    isLoading?: boolean;
}

const RightSideContainer: React.FC<CreateNewTagProps> = ({ productTagDetails, pageMode, isLoading }) => {
    return (
        <div className="flex-1 min-w-0 relative">
            {/* An overlay rather than a swap: the form underneath keeps its state. */}
            {isLoading && (
                <div className="absolute inset-0 bg-white/60 z-10 rounded" />
            )}
            <CreateNewTag productTagDetails={productTagDetails} pageMode={pageMode} />
        </div>
    )
}
export default RightSideContainer;
